import React from 'react';
import '../../assets/css/loader.css'

// ==============================|| LOADER ||============================== //

const Loader = () => {
  return (
    <div className="loading">
      <div className="la-ball-newton-cradle la-3x la-dark">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loader;
